import type { FeatureStyleNode } from '../feature-style.model';

export interface AmplitudeParams {
  of: string;
}

export const AMPLITUDE_DEFAULTS: FeatureStyleNode = {
  line: { color: 'sky', strokeWidth: 2 },
  subparts: {
    top: { visible: true, line: {} },
    bottom: { visible: false, line: {} },
    midline: { visible: true, line: { color: 'amber', dash: 3 } },
    topLine: { visible: false, line: { dash: 3 } },
    bottomLine: { visible: false, line: { dash: 3 } },
  },
};
